import { getArgs } from "../utils";
import api from "./api";

const route = "/invoices";

const InvoicesService = {
  getInvoicesAdmin: (filters) =>
    api.get(
      `${route}/admin?${getArgs(
        filters
      )}`
    ),
};

export default InvoicesService;